<template>
    <div class="quizBlock">
        <div v-html="question" class="text-center"></div>
        <div v-if="block.data.lineType === 'multi'">
            <b-form-textarea
                v-model="selectedAnswer"
                :placeholder="$t('typeYourAnswerHere')"
                rows="4"
                class="mt-3"
                max-rows="20"
                @input="select(selectedAnswer)"
            ></b-form-textarea>
        </div>
        <div v-else-if="block.data.lineType === 'single'">
            <b-form-input
                v-model="selectedAnswer"
                :placeholder="$t('typeYourAnswerHere')"
                class="mt-3"
                @input="select(selectedAnswer)"
            ></b-form-input>
        </div>
    </div>
</template>
<script>

export default {
    name: 'OpenTextBlock',
    props: {
        block: Object,
        textDir: {
            type: String,
            default: ''
        }
    },
    computed: {
        question() {
            if (this.block.data.question) {
                if (this.block.data.question.includes('src') || this.block.data.question.includes('href')) {
                    return this.block.data.question.replace(/(src="|href=")(\/)(.*?)("(>|\s))/g, `$1${process.env.VUE_APP_APIURL}$2$3$4`);
                }
                return this.block.data.question.replace(/(^\/)/g, `${process.env.VUE_APP_APIURL}$1`);
            }
            return '';
        },
    },
    data(){
        return {
            selectedAnswer: null
        }
    },
    created(){
        if (this.block.response){
            this.selectedAnswer = this.block.response;
        }
    },
    methods: {
        select(selected){
            this.selectedAnswer = selected;
            this.$emit('answerSelected', this.selectedAnswer);
        }
    }
}

</script>
